import { configureStore } from "@reduxjs/toolkit";
import counterReducer from "./counterSlice";
import galleryReducer from "./gallerySlice";
import modsReducer from "./modsSlice";
import selectionReducer from "./selectionSlice";
import reviewReducer from "./reviewSlice";
import { objectSlice, ObjectState } from "./objectSlice";

export const store = configureStore({
    reducer: {
        counter: counterReducer,
        gallery: galleryReducer,
        mods: modsReducer,
        selection: selectionReducer,
        review: reviewReducer,
        object: objectSlice.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
